export const POLICIES_AND_RECOMMENDATIONS_PDF_LINK =
  'https://cdn-assets.peachjar.com/portal-app/onboarding/Policies+and+Recommendations.pdf';
export const PRESS_RELEASE_TEMPLATE_LINK =
  'https://cdn-assets.peachjar.com/portal-app/onboarding/Press+Release+Template.docx';
export const SOCIAL_MEDIA_TEMPLATE_LINK =
  'https://cdn-assets.peachjar.com/portal-app/onboarding/Peachjar+Social+Media+Post+Templates.docx';
export const GEOCORE_LOGIN_LINK = 'https://peachjar.com/index.php?a=4';
export const COMMUNITY_PARTNERS_LIST_TEMPLATE_LINK =
  'https://cdn-assets.peachjar.com/portal-app/onboarding/Community+Partners+List.xlsx';



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/confirm/constants.js